var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ObjectStoreSelectButtonPopover,{attrs:{"target":_setup.target,"title":_setup.title}},[_c(_setup.DescribeObjectStore,{attrs:{"what":_vm.what,"storage-info":_vm.objectStore}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }